export default {
  about: {},
  posts: {},
  photos: {},
  videos: {},
  files: {},
  catalogs: {}
}
